import { useContext } from 'react';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

import { useUtils } from '../../utils/useUtils';

export const useMaterialProgressBar = (props, widgetName) => {
  const { getConfig } = useUtils(props, widgetName);
  const { actions } = useContext(MainContext);
  const { t, i18n } = useTranslation();

  const currentStepName = actions.userState.getCurrentStepName();
  const stepDetails = actions.userState.getCurrentStepDetails();
  const steps = actions.settings.getUserConfigProp('steps');
  const backgroundImage = getConfig('backgroundImage', '');
  const backgroundPosition = getConfig('backgroundPosition', 'left');
  const finishingStep = getConfig('finishingStep');
  const stepperAriaLabel = t(`${props.name}.stepperAriaLabel`);

  const stages = steps
    .filter((step) => (step.flow ? step.flow === stepDetails.flow : true))
    .reduce((result, current) => {
      if (current.progressBarStep && !result[current.progressBarStep]) {
        result[current.progressBarStep] = {
          ...current,
          label: actions.userState.getStepDetails(current.stepName).label,
        };
      }
      return result;
    }, {});

  const progressBarSteps = Object.values(stages);

  const currentStepDetails = actions.userState.getCurrentStepDetails();

  const activeStep = steps.find((stage) => stage.stepName === currentStepDetails.stepName);
  const allStepsCompleted = finishingStep === currentStepName;
  const activeStepNumber = allStepsCompleted ? activeStep.progressBarStep + 1 : activeStep.progressBarStep - 1;

  const getStepDescription = (step, index) => {
    const stepNumber = index + 1;
    const isCompleted = stepNumber < activeStep.progressBarStep;
    const isCurrent = activeStep.progressBarStep === stepNumber;

    const baseLabel = i18n.exists(`${props.name}.baseLabel`)
      ? t(`${props.name}.baseLabel`, {
          label: step.label,
          stepNumber,
        })
      : '';

    if (isCompleted && i18n.exists(`${props.name}.completedStepIndicator`)) {
      return `${baseLabel} ${t(`${props.name}.completedStepIndicator`)}`;
    }

    if (isCurrent && i18n.exists(`${props.name}.currentStepIndicator`)) {
      return `${baseLabel} ${t(`${props.name}.currentStepIndicator`)}`;
    }

    return baseLabel;
  };

  return {
    activeStep,
    progressBarSteps,
    activeStepNumber,
    backgroundImage,
    backgroundPosition,
    getStepDescription,
    stepperAriaLabel,
  };
};
